<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <div class="row">
                    <div class="col-md col-sm-6">
                        <form-input v-model="query.syear" id="syear" label="學年度" type="number"></form-input>
                    </div>
                    <div class="col-md col-sm-6">
                        <form-select v-model="query.semester" id="semester" label="學期">
                            <div is="option" value="">全部</div>
                            <div is="option" value="u">上</div>
                            <div is="option" value="d">下</div>
                        </form-select>
                    </div>
                    <div class="col-md col-sm-12">
                        <form-input v-model="query.classname" id="classname" label="班級" type="text"></form-input>
                    </div>
                    <div class="col-md col-sm-12">
                        <form-date-input v-model="query.date" id="date" label="日期"></form-date-input>
                    </div>
                    <div class="col-md-12 col-sm-12">
                        <btn-group :load="reload" :insert="insert" :del="del" :deleteItems="deleteItem.length"></btn-group>
                    </div>
                </div>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>學年度-學期</th>
                            <th>班級</th>
                            <th>日期</th>
                            <th>應到/未到/免朝會</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.MorningmeetingStudentID">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.MorningmeetingStudentID" /></td>
                        <td data-th="學年度-學期">{{item.SYear}}-{{item.Semester|semester}}</td>
                        <td data-th="班級">{{item.ClassName}}</td>
                        <td data-th="日期"><b-button size="sm" variant="link" @click="edit(item.MorningmeetingStudentID)">{{item.Date|date('yyyy/mm/dd')}}</b-button></td>
                        <td data-th="應到/未到/免朝會">{{item.Should}}/{{item.NoArrive}}/{{item.Exempt}}</td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload" @edit="edit"></Detail>
    </page-main>
</template>

<script>
    import Detail from './morningmeetingStudentDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'morningmeetingStudent',
        api: '/api/morningmeetingstudent/',
        components: { Detail }
    });
</script>

<style>
</style>